/* eslint-disable react/prop-types */

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import UserTableRow from './UserTableRow';
import UserTableRowSkeleton from './UserTableRowSkeleton';
import { usersSelectors } from './reducer';

import { useDispatchWithProgress } from '../../hooks/useDispatchWithProgress';
import { usersActions } from './actions';
import { invitationsActions } from '../invitations/actions';

const UsersTableRows = ({ targetRef }) => {
  const dispatch = useDispatch();

  const activeReview = useSelector(usersSelectors.activeReview);
  const deactivatedActiveReview = useSelector(usersSelectors.deactivatedActiveReview);
  const selectedAccountNumber = useSelector(state => state.user.get('userAccount')?.number);
  const selectedUserId = useSelector(usersSelectors.selectedUserId);
  const users = useSelector(usersSelectors.usersByIdList);
  const isModalOpen = useSelector(usersSelectors.isModalOpen);

  const loadInitialUsers = useDispatchWithProgress(usersActions.loadInitialUsers);
  const loadInitialDeactivatedUsers = useDispatchWithProgress(usersActions.loadInitialDeactivatedUsers);
  const loadInvitationHeaderTotals = useDispatchWithProgress(invitationsActions.getInvitationCounts);

  useEffect(() => {
    if (activeReview) {
      loadInitialUsers(selectedAccountNumber);
      loadInvitationHeaderTotals(selectedAccountNumber);
    } else if (deactivatedActiveReview) {
      loadInitialDeactivatedUsers(selectedAccountNumber);
    }

    return () => {
      dispatch({ type: usersActions.resetUsers.name });
    };
  }, [activeReview, deactivatedActiveReview, selectedAccountNumber]);

  return (
    (activeReview || deactivatedActiveReview) && (
      <>
        {users.map((user, index) => (
          <UserTableRow
            key={user.id}
            user={user}
            {...(user.id === selectedUserId && { userIsSelected: selectedUserId && isModalOpen })}
            {...(index === users.length - 5 && { targetRef })}
          />
        ))}
        <UserTableRowSkeleton targetRef={targetRef} />
      </>
    )
  );
};

export default UsersTableRows;
